import type { Image } from '@frontend/libs/types/media'
import type React from 'react'

import { parseHtml } from '@frontend/libs/utils'
import placeholder from '@images/placeholder-wide.jpg'
import { Button, Image as NextUIImage } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'
import { Link } from 'react-router-dom'

export interface BlogItemProps {
  categories: string
  excerpt: string
  image: Image
  permalink: string
  title: string
}

function BlogItem({
  categories,
  excerpt,
  image,
  permalink,
  title,
}: Readonly<BlogItemProps>): React.JSX.Element {
  return (
    <article className="box-overlay relative aspect-[4/5] overflow-hidden md:aspect-[10/9]">
      <div className="absolute bottom-0 left-0 right-0 z-20 px-4 py-6 text-center md:py-10">
        <div className="mx-auto max-w-screen-lg">
          <span className="mb-0 line-clamp-2 uppercase text-white">
            {parseHtml(categories)}
          </span>
          <h3 className="mb-2 text-xl font-medium uppercase leading-tight text-white md:text-2xl">
            {parseHtml(title)}
          </h3>
          <p className="mb-4 line-clamp-3 text-base text-white md:line-clamp-4">
            {parseHtml(excerpt)}
          </p>
          <Button
            as={Link}
            className="!hover:opacity-100 h-auto bg-white px-4 py-3 font-medium uppercase data-[hover=true]:bg-white"
            to={permalink}
            variant="light"
          >
            {__('Discover More', 'asavagroup')}
          </Button>
        </div>
      </div>
      <NextUIImage
        alt={image.alt}
        className="absolute left-0 top-0 !h-full w-full object-cover"
        fallbackSrc={placeholder}
        removeWrapper
        shadow="none"
        src={image.sizes.medium}
        srcSet={image.srcset}
      />
    </article>
  )
}

export default BlogItem
